import React, { useEffect, useState } from "react";

const OauthSuccess = ({
  redirectUrl = "https://app.noki.ai/",
  countdownSeconds = 5,
}) => {
  const [seconds, setSeconds] = useState(countdownSeconds);

  const redirectNow = () => {
    window.location.href = redirectUrl;
  };

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds <= 1) {
          clearInterval(countdownInterval);
          redirectNow();
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [redirectUrl]);

  return (
    <div style={styles.container}>
      <div style={styles.contentBox}>
        <h1 style={styles.heading}>Authentication Successful!</h1>
        <p style={styles.text}>
          Hello, you are now successfully authenticated with Noki.
        </p>
        <p style={styles.text}>You can use our services from now!</p>

        <div style={styles.redirectInfo}>
          You will be redirected to Noki in
          <span style={styles.countdown}>{seconds}</span> seconds...
        </div>

        <button
          style={styles.button}
          onClick={redirectNow}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#45a049")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#4CAF50")
          }
        >
          Go to Noki
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
    padding: "50px",
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  contentBox: {
    backgroundColor: "white",
    borderRadius: "10px",
    padding: "30px",
    maxWidth: "600px",
    margin: "0 auto",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  },
  heading: {
    color: "#4CAF50",
    marginBottom: "20px",
  },
  text: {
    margin: "10px 0",
    fontSize: "16px",
    lineHeight: "1.5",
  },
  redirectInfo: {
    margin: "20px 0",
    fontSize: "18px",
  },
  countdown: {
    fontWeight: "bold",
    color: "#4CAF50",
    margin: "0 5px",
  },
  link: {
    color: "#4CAF50",
    textDecoration: "none",
    fontWeight: "bold",
  },
  button: {
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    padding: "12px 24px",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    fontSize: "16px",
    margin: "20px 0",
    cursor: "pointer",
    borderRadius: "5px",
    transition: "background-color 0.3s",
  },
};

export default OauthSuccess;
